<template>
<div class="page-wrapper">
  <search-list
   :projectList = "projectList"
    @findData="findData">
  </search-list>
  <div class="page-wrapper">
  <table-list
      :columns="columns"
      :data="tableData"
      :total="total"
      :current="current"
      :loading="loading"
      @change-page="changePage"
    >
      <Button type="primary" class="mb16 mr8" @click="creatBill" v-p="{api:'bill/create'}">新建应收账单</Button>
      <Button type="primary" class="mb16" @click="batchSaveCertificate" v-p="{api:'certificate/batchSaveCertificate'}">企业计划收款</Button>
    </table-list>
  </div>
    <confirm-modal :n = "confirmKey" :action="`收取第${periods}期账单 `" :actionother="'线下收款对账时效为当前日期+1个工作日！'"  @cancel = "collection"></confirm-modal>
    <confirm-modal :n = "deleteKey" :action="'要作废此应收账单，作废后将无法恢复'"  @cancel = "deleteReceivableBill"></confirm-modal>
</div>

</template>

<script type="text/ecmascript-6">

import { getList, deleteReceivableBill,canCertificate } from 'api/accountsReceivable'
import SearchList from './components/SearchList';
import ConfirmModal from 'components/CancelModal/index';
import {formatMoney} from '@/utils/format'

export default {
  name:'accountsreceivable',
  components:{
    SearchList,
    ConfirmModal
  },
  watch: {
    $route(to, from) {
     if(from.name=='collection' || from.name=='creatbill' ||from.name=='enterprisecollection'){
      this.findData(this.searchData)
     }
    }
  },
  data () {
    return {
      loading:false, // true
      total:0,
      current:1,
      confirmKey:0,
      deleteKey:0,
      entCollectionKey:0,
      periods:1,
      billNumber:'',
      contractCode:'',
      projectFid:'',
      projectList:[],
      searchData:null,
      columns:[
        {
          type:'index',
          width:60,
          align:'center'
        },
        {
          title:' '
        },
        {
          title:'账单编号',
          key:'billNumber',
          align:'center',
          width:210,
          render: (h,params) => {
            return h('a',{
               on:{
                click:()=>{
                this.$router.push({
                      name: 'accountsreceivabledetail',
                      query:{
                        cCode: params.row.contractCode,
                        bNum:params.row.billNumber
                      }
                    })
                }
              }
            }, params.row.billNumber)
          }
        },
        {
          title:' '
        },
        {
          title:'项目',
          key:'projectName',
          align:'center',
          width:160
        },
        {
          title:' '
        },
        {
          title:'房间/床位号',
          key:'stockNumber',
          align:'center',
          width:120
        },
        {
          title:' '
        },
        {
          title:'客户名称',
          key:'customerName',
          align:'center',
          width:220
        },
        {
          title:' '
        },
        {
          title:'费用项',
          key:'costCodeName',
          align:'center',
          width:80
        },
        {
          title:' '
        },
        {
          title:'期数',
          key:'periods',
          align:'center',
          width:60
        },
        {
          title:' '
        },
        {
          title:'单据状态',
          key:'verificateStatusName',
          align:'center',
          width:90
        },
        {
          title:' '
        },
        {
          title:'应收金额',
          key:'receiptBillAmount',
          align:'center',
           width:120,
           render: (h,params) => {
             return h('div',
             {
               style:{
                 'text-align':'right'
               }
             },formatMoney(params.row.receiptBillAmount))
           }
        },
        {
          title:' '
        },
        {
          title:'实收金额',
          key:'receivedBillAmount',
          align:'center',
           width:120,
           render: (h,params) => {
             return h('div',
             {
               style:{
                 'text-align':'right'
               }
             },
             formatMoney(params.row.receivedBillAmount))
           }

        },
        {
          title:' '
        },
        {
          title:'合同号/预订单号',
          key:'contractCode',
          align:'center',
          width:180
        },
        {
          title:' '
        },
        {
          title:'创建时间',
          key:'createTime',
          align:'center',
          width:180
        },
        {
          title:' '
        },
        {
          title:'计划收款日期',
          key:'predictCollectDate',
          align:'center',
          width:110
        },
        {
          title:' '
        },
        {
          title:'开始日期',
          key:'billStartTime',
          align:'center',
          width:110
        },
        {
          title:' '
        },
        {
          title:'结束日期',
          key:'billEndTime',
          align:'center',
          width:110
        },
        {
          title:' ',
        },
        {
          title:'操作',
          key:'surCode',
          align:'center',
          fixed: 'right',
          width:100,
          render:(h,params) => {
            let notShowDelete = params.row.costCode == 'khdj' || params.row.costCode == 'khfz' || params.row.costCode == 'khyj' || params.row.costCode == 'khfwf' || params.row.costCode == 'khyqwyj'
            return h('div',[h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'certificate/savePaymentVoucher'
                  }
                }
              ],
              style:{
                display:params.row.verificateStatus === 1 || params.row.periods==1 || params.row.costCode == 'khdj'? 'none':'inline-block',
                marginRight: '5px'
              },
              on:{
                click: ()=>{
                  this.isCanCertificate(params)

                  // this.billNumber = params.row.billNumber
                  // this.contractCode = params.row.contractCode
                  // this.projectFid = params.row.projectFid
                  // if (params.row.periods){
                  //   this.periods = params.row.periods
                  //   this.confirmKey++
                  // }else {
                  //   this.$router.push({
                  //     name: 'collection',
                  //     query:{
                  //       proId:params.row.projectFid,
                  //       bNum: params.row.billNumber,
                  //       cCode: params.row.contractCode
                  //     }
                  //   })
                  // }
                }
              }
            },'收款'),
            h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'bill/deleteReceivableBill'
                  }
                }
              ],
              style:{
                display:params.row.verificateStatus === 0 && !notShowDelete? 'inline-block':'none',
                marginRight: '5px'
              },
              on:{
                click: () => {
                  this.billNumber = params.row.billNumber
                  this.deleteKey++
                }
              }
            },'作废')])
          }
        }
      ],
      tableData:[]
    };
 },
 methods:{
   changePage(n){
      this.loading  = true
      this.current = n;
      this.searchData.page = n
      this.getList(this.searchData)
    },
    collection(){
      this.$router.push({
        name: 'collection',
        query:{
          proId:this.projectFid,
          bNum:this.billNumber,
          cCode: this.contractCode
        }
      })
    },
   findData(data){
     this.current = 1
     this.searchData = data
     this.searchData.page = 1
     this.getList(this.searchData)
   },
   getList(data){
     this.loading = true
     getList(data).then(res => {
      this.tableData = res.data.rows
      this.total = res.data.total
      this.loading = false
     }).catch( res => {
       this.loading = false
     })

   },
   creatBill(){
      this.$router.push({name: 'creatbill'})
   },
   batchSaveCertificate(){
     this.entCollectionKey++
     this.$router.push({name: 'enterprisecollection',query:{isFirst:0,key:this.entCollectionKey}})
   },
   deleteReceivableBill(){
     deleteReceivableBill(this.billNumber).then( res => {
       this.$Message.success('作废应收账单成功!');
       this.getList(this.searchData)
     })
   },
   isCanCertificate(params){
     canCertificate({billNum:params.row.billNumber}).then(res => {
        this.billNumber = params.row.billNumber
        this.contractCode = params.row.contractCode
        this.projectFid = params.row.projectFid
        if (params.row.periods){
          this.periods = params.row.periods
          this.confirmKey++
        }else {
          this.$router.push({
            name: 'collection',
            query:{
              proId:params.row.projectFid,
              bNum: params.row.billNumber,
              cCode: params.row.contractCode
            }
          })
        }
     })
   }
 }
}
</script>
